import React from 'react';
import { Box, } from '@waglabs/box-next';
export const Container = ({ children, ...rest }) => (React.createElement(Box, Object.assign({ maxWidth: ['100%', '688px', '1120px', '1600px'], mx: "auto", px: ['16px', '24px'], width: 1 }, rest), children));
